interface TranscriptionJobBadgeProps {
  status: string | null;
  error?: string | null;
}

export function TranscriptionJobBadge({ status, error }: TranscriptionJobBadgeProps) {
  if (!status) return null;

  const styles: Record<string, string> = {
    queued: 'bg-yellow-100 text-yellow-800',
    running: 'bg-blue-100 text-blue-800',
    done: 'bg-green-100 text-green-800',
    error: 'bg-red-100 text-red-800',
  };

  const label = status === 'error' && error ? 'error' : status;

  return (
    <span
      title={error ?? undefined}
      className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium ${styles[status] ?? 'bg-gray-100 text-gray-700'}`}
    >
      {label}
    </span>
  );
}
